export const fmtMoney = (n) =>
  Number(n ?? 0).toLocaleString(undefined, { maximumFractionDigits: 2 })

export const withQuery = (base, params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&")
  return qs ? `${base}${base.includes("?") ? "&" : "?"}${qs}` : base
}

export const paxText = (p) =>
  p.passenger_from || p.passenger_to
    ? `${p.passenger_from ?? "?"}–${p.passenger_to ?? "?"} pax`
    : ""

export const goTo = (url) =>
  window.Turbolinks?.visit ? window.Turbolinks.visit(url) : window.location.assign(url)
